"use client";

import { FormattedMessage } from "react-intl";
import GdprIcon from "@/assets/svg/gdpr/gdpr.svg";

const Copyright = () => {
  return (
    <>
      <div className="mt-8 border-t border-gray-200 pt-8 lg:flex lg:items-center lg:justify-between">
        <div className="text-gray-400 text-xs pt-1">
          <p>
            <FormattedMessage
              defaultMessage={
                "Copyright © 2026 Chatsystem, Inc. All rights reserved."
              }
              id="footer.tab.finalCopyright"
            />
          </p>
        </div>
        <div className="mt-4 lg:mt-0 flex items-center gap-2 text-gray-500 text-xs">
          <GdprIcon className="h-20 w-20" title="GDPR" />
          <span>
            <FormattedMessage
              defaultMessage="GDPR Compliant"
              id="footer.gdpr.compliant"
            />
          </span>
        </div>
      </div>
    </>
  );
};

export default Copyright;
